// not-auth.guard.ts
import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { AuthenticationService } from '../services/authentication.service';
import { TokenStorageService } from '../services/token-storage.service';
import { UtilsService } from '../services/utils.service';

export const NotAuthGuard: CanActivateFn = (route) => {
  const auth = inject(AuthenticationService);
  const tokenSvc = inject(TokenStorageService);
  const utils = inject(UtilsService);

  // hydrate once from localStorage if needed
  const user = tokenSvc.loadUserFromLocalStorage();
  const isLoggedIn = !!(user && user.userId);
  auth.isAuthenticated = isLoggedIn;

  if (isLoggedIn) {
    // already logged in → go to dashboard
    utils.redirectUserToDashboard(route.queryParams['returnUrl']);
    return false; // cancel navigation to /login
  }

  // not logged in → allow access to /login
  return true;
};
